module.exports = "/* CSS classes\r\n\r\n.completer-holder\r\n.completer-input\r\n.completer-dropdown-holder\r\n.completer-dropdown\r\n.completer-searching\r\n.completer-no-results\r\n.completer-row\r\n.completer-image-holder\r\n.completer-image\r\n.completer-image-default\r\n.completer-title\r\n.completer-description\r\n.completer-list-item-holder\r\n.completer-list-item\r\n.completer-selected-row\r\n\r\n\r\n*/\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/my-auto-complete/my-auto-complete.component.css
// module id = ./src/app/components/my-auto-complete/my-auto-complete.component.css
// module chunks = main